<template>
  <div v-if="sets.length === 5">
    <div v-if="$mq.lg" class="grid grid-cols-5 mb-40 gap-32">
      <div v-for="(set, key) in sets" :key="key">
        <div @click="filter(set.filter, set.value)" class="w-full cursor-pointer">
          <img class="w-full h-170 object-cover mb-12"
               :src="set.highlightedArtwork.images.fullImage['md']"
               :srcset="set.highlightedArtwork.images.fullImage['srcSets']"
               :alt="set.highlightedArtwork.images.altImage">

          <h3 class="text-18">{{ set.title }}</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <swiper-container ref="carousel" class="carousel-container" :slides-per-view="2"
                        swiper-slide-next="test"
                        :space-between="15"
                        :enabled="true"
                        loading="lazy">
        <swiper-slide v-for="(set, key) in sets" :key="key">
          <div @click="filter(set.filter, set.value)" class="w-full relative">
            <img class="w-full object-cover h-120 rounded-lg"
                 :src="set.highlightedArtwork.images.fullImage['md']"
                 :srcset="set.highlightedArtwork.images.fullImage['srcSets']"
                 :alt="set.highlightedArtwork.images.altImage">

            <div class="w-90% absolute bottom-0 left-0 pl-8 pb-12">
              <h3 class="bg-white px-6 py-4 text-12 rounded-md fit-content" style="font-family: sans-serif">
                {{ set.title }}
              </h3>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>

<script>
import { register } from 'swiper/element/bundle';
import 'swiper/swiper-bundle.css';

register();
export default {
  name: "TheExhibitSets",

  inject: {
    action: "queryActions",
  },

  data () {
    return {
      sets: jsonFromPage('#data-artwork-sets')
    }
  },

  methods: {
    filter (filter, value) {
      this.action.clear()
      let query = {};
      this.$set(query, filter, value)
      this.action.sync(query);
    },
  },

  computed: {
    defaultQuery () {
      return jsonFromPage('#data-default-query')
    },
  }
}
</script>
